import { Routes } from '@angular/router';
import {ChartOfAccountsComponent} from "./chart-of-accounts.component";
import {AddEditAccountsComponent} from "./add-edit-accounts/add-edit-accounts.component";
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { ChartOfAccountsDetailComponent } from './chart-of-accounts-detail/chart-of-accounts-detail.component';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';

export const chartOfAccountRoutes: Routes = [
    {
        path: 'chart-of-accounts',
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: { enterpriseModules: ['ACCOUNTING', 'GENERAL_LEDGER'], enterpriseFeatureLabel: 'Accounting' },
        children: [
            {
                path: '',
                component: ChartOfAccountsComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.chart_of_accounts.accounts.view }
            },
            {
                path: 'add/:id',
                component: AddEditAccountsComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.chart_of_accounts.accounts.create }
            },
            {
                path: 'view/:id',
                component: ChartOfAccountsDetailComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.chart_of_accounts.accounts.view }
            },
            {
                path: 'edit/:id',
                component: AddEditAccountsComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.chart_of_accounts.accounts.edit }
            }
        ]
    },
];
